/**
 * Public property-photo save deterrence (P3).
 *
 * ORDINARY-USER FRICTION, NOT DRM. Right-click "Save image as" and drag-to-desktop are deterred
 * on marked public property photos. DevTools, direct HTTP requests and screenshots remain fully
 * possible; the transparent tenant watermark (P2) is the durable protection. Admin is never
 * touched (this module ships only in the public bundle).
 *
 * ONE idempotent, document-level DELEGATED module: a single contextmenu + dragstart listener
 * filtered to `.js-protected-property-photo` via closest(), so lazily appended / InfiniteScroll /
 * Vue-rerendered cards are covered without re-binding and WITHOUT any global contextmenu or
 * keyboard blocking. Ordinary text/link right-click, selection, copy/paste and form input are
 * unaffected. Fancybox/lightbox use click + keyboard (not contextmenu/dragstart), so zoom, swipe,
 * close and keyboard navigation keep working.
 */
(function () {
  if (typeof document === 'undefined') {
    return;
  }
  // Idempotent: never bind twice, even if the bundle is evaluated more than once.
  if (window.__propertyPhotoProtectionBound) {
    return;
  }
  window.__propertyPhotoProtectionBound = true;

  var SELECTOR = '.js-protected-property-photo';

  function isProtectedPhoto(target) {
    return !!(target && typeof target.closest === 'function' && target.closest(SELECTOR));
  }

  // Right-click "Save image" deterrence — ONLY on marked photos; everything else is untouched.
  document.addEventListener('contextmenu', function (event) {
    if (isProtectedPhoto(event.target)) {
      event.preventDefault();
    }
  });

  // Drag-to-desktop / drag-into-another-tab deterrence for the same scoped photos.
  document.addEventListener('dragstart', function (event) {
    if (isProtectedPhoto(event.target)) {
      event.preventDefault();
    }
  });
})();
